<template>
	<v-container class="mt-4 ml-2" fluid>
		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title primary-title>
						<span class="text-subtitle-1"><v-icon left>mdi-fingerprint</v-icon>Comentarios nómina</span>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							dark
							@click="initialize()"
							small
							tile
						>
							Actualizar
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  hide-details
                  item-text="ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>

				      <v-col cols="12" sm="6" md="3" lg="2">
				      	<v-select
					      	:items="semanasCiclo"
					      	v-model="selectedHeaders"
					      	label="# Semana"
					      	filled
                  dense
					      	hide-details
					      	item-text="bloque"
					      	item-value="value"
					      	:disabled="!semanasCiclo.length"
				      	></v-select>
				      </v-col>

				      <v-col cols="12" md="6" lg="4">
		          	<v-radio-group
						      v-model="opcionFiltro"
						      row
						      hide-details
						      class="mt-0 pt-0"
						    >
						      <v-radio
						        label="Pendiente"
						        :value="0"
						      ></v-radio>
						      <v-radio
						        label="Aceptados"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Rechazados"
						        :value="2"
						      ></v-radio>
						      <v-radio
						        label="Todos"
						        :value="3"
						      ></v-radio>
						    </v-radio-group>
				      </v-col>
				    </v-row>

				    <v-row>
							<v-col cols="12">
						    <v-row justify="space-between" align="center">

						    	<v-col cols="12" md="6">
								    <div class="black--text">
								    	Avance: {{ porcentajeAvance }} %
								    </div>
						    	</v-col>

						    	<v-col cols="12" md="6">
								    <v-text-field
								      label="Buscar"
								      v-model="search"
								      dense
								      single-line
								      filled
								      hide-details
								    ></v-text-field>
						    	</v-col>
						    </v-row>

				        <v-data-table
	            		:headers="headers"
	            		:items="filterEntradas"
	            		class="elevation-0"
	            		:search="search"
	            		:mobile-breakpoint="100"
	            		dense
            		>
            			<!-- Valores que ocupan botons, chips, iconos, etc -->
	            		<template v-slot:item.nombre_completo="{ item }">
	            			<span 
	            				:class="item.estatus_nomina == 1 ? 'green--text' : item.estatus_nomina == 2 ? 'red--text' : ''"
	            				@click="verComentarios( item )"
	            				type="button"
	            			>
	            				{{ item.nombre_completo }}
	            			</span>
	            		</template>

	            		<!-- Valores que ocupan botons, chips, iconos, etc -->
	            		<template v-slot:item.tipo_pago="{ item }">
	            			<v-chip v-if="item.tipo_pago == 2" small color="green" dark >Hora</v-chip>
	            			<v-chip v-if="item.tipo_pago == 1" small color="blue" dark >Dia</v-chip>
	            			<v-chip v-if="item.tipo_pago == null || item.tipo_pago == 0" small color="orange" dark >Sin Tipo Pago</v-chip>
	            		</template>

	            		<template v-slot:item.confirmacion_comisiones="{ item }">
	            			<v-chip v-if="(item.confirmacion_comisiones == 3)" small color="green" dark >Aceptadas</v-chip>
	            			<v-chip v-if="(item.confirmacion_comisiones == 4)" small color="blue" dark >Rechazadas</v-chip>
	            			<v-chip v-if="item.puesto == 'ENCARGADA DE SUCURSAL' && (item.confirmacion_comisiones == null || item.tipo_pago == 0)" small color="orange" dark >Pendiente</v-chip>
	            		</template>

	            		<template v-slot:item.monto_laborado="{ item }">
	            			<span type="button" @click="goPrenomina(item.nombre_completo )">{{ item.monto_laborado }}</span>
	            		</template>

	            		<template v-slot:item.monto_horas_extras="{ item }">
	            			<span type="button" @click="goHorasExtras(item.nombre_completo )">{{ item.monto_horas_extras }}</span> 
	            		</template>

	            		<template v-slot:item.comisiones_semana="{ item }">
	            			<span type="button" @click="goComisiones(item.nombre_completo )">{{ item.comisiones_semana }}</span>
	            		</template>

	            		<template v-slot:item.monto_total_rebajes="{ item }">
	            			<span type="button" @click="goRebajes(item.nombre_completo )">{{ item.monto_total_rebajes }}</span>
	            		</template>

	            		<template v-slot:item.monto_total_bonos="{ item }">
	            			<span v-if="item.puesto != 'Teacher'" @click="goBonos(item.nombre_completo )">{{ item.monto_total_bonos }}</span>
	            			<span v-if="item.puesto == 'Teacher'" >{{ item.monto_total_bonos }}</span>
	            		</template>

	            		<template v-slot:item.monto_total="{ item }">
	            			<span type="button" @click="formulaMontoTotal(item), dialogMontoTotal = true">{{ item.monto_total }}</span>
	            		</template>

		            	<template v-slot:no-data>
		            		<v-btn
			            		color="primary"
			            		@click="initialize"
			            		small
		            		>
		            			Actualizar
			            	</v-btn>
			            </template>
			          </v-data-table>
							</v-col>
						</v-row>

			    </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<v-dialog
		  v-model="dialogComentarios"
		  max-width="500px"
		  v-if="renglonNomina"
		>
			<v-card>
				<v-card-title primary-title>
				  Comentarios de nómina
				</v-card-title>

			  <v-card-text>
			  	<v-row>
			  		<v-col cols="12"
			  			v-for="(mensaje, i) in renglonNomina.comentarios" :key="i"
			  		>
					  	<p 
					  		:class="`pa-2 ma-0 mb-4 ${ mensaje.id_usuario != getdatosUsuarioERPERP.id_trabajador ? 'mensajeIzq' : 'mensajeDer' }`">
					    	{{ mensaje.comentarios }}
					    	<br/>
					    	{{ mensaje.nombre_completo }}
					  	</p>
			  		</v-col>
			  	</v-row>
			    <br/>
			  </v-card-text>

			  <v-card-text>
			    <v-textarea
			  		v-model="respuesta"
			  		filled
			  		:rows="3"
			  		auto-grow
			  		label="respuesta al colaborador"
			  		hide-details
			  	></v-textarea>
			  </v-card-text>
			  
			  <v-card-actions>
			  	<v-btn 
			  		color="black"
			  		@click="dialogComentarios = false"
			  		tile
			  		dark
			  		small
			  	>
			  		<v-icon left span>mdi-cancel</v-icon>
			  		Cancelar
			  	</v-btn>
			    <v-spacer></v-spacer>
			  	<v-btn 
			  		color="success"
			  		@click="responder( )"
			  		tile
			  		small
			  	>
			  		<v-icon left span>mdi-content-save</v-icon>
			  		Agregar comentario
			  	</v-btn>
			  </v-card-actions>
			</v-card>	
		</v-dialog>
		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';


	import Administrativa        from '@/components/nomina/Administrativa.vue';

	import validarErrores  from '@/mixins/validarErrores'
	import XLSX            from 'xlsx'
	import funcionesExcel  from '@/mixins/funcionesExcel'


	export default {
		components:{
			Alerta,
			carga,
			Administrativa,
		},

		mixins: [ validarErrores, funcionesExcel ],

		data: () => ({
    	// Alertas
			parametros:{
				dialogError: false,
				mensaje: '',
				color: ''
			},

			respuestaAlerta:false,
			loader: true,
			cargar: false,

			ciclos:[],
			ciclo:null,
			id_ciclo: 0,

      // Filtros: 
			fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

			estatus: null,

			selectedHeaders:null,
			semanasCiclo: [],
			_configurandoFiltros: false,

      // tabla
			search:'',

			nominaActual: [],
			nominaEstatus: [],
			entradassalidasteachers: [],

			headers: [
				{ text: 'Empleado'              , value: 'nombre_completo'      },
				{ text: 'Puesto'                , value: 'puesto'               },
				{ text: 'Plantel'               , value: 'plantel'              },
			],

			tab: null,
			dataNominaAnterior: [],

			renglonNomina: null,
			dialogComentarios: false,
			respuesta: '',

			opcionFiltro: 3

		}),

		watch: {
			ciclo( value, oldValue ){
				if( !value || this._configurandoFiltros ) return
				if( !oldValue || oldValue.id_ciclo !== value.id_ciclo ){
					const semanaAntes = this.selectedHeaders
					this.actualizarSemanas()
					// Si el número de semana no cambió, selectedHeaders no dispara: recargar aquí
					if( this.selectedHeaders && this.selectedHeaders === semanaAntes ){
						this.initialize()
					}
				}
			},
			selectedHeaders( value, oldValue ){
				if( this._configurandoFiltros || !value || !this.ciclo ) return
				if( value === oldValue ) return
				this.initialize()
			},
		},

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			porcentajeAvance(){
				if( !this.nominaActual.length ) return 0
				const aceptados = this.nominaActual.filter( el => el.estatus_nomina == 1 ).length
				if( !aceptados ) return 0
				return ((aceptados / this.nominaActual.length) * 100).toFixed(2)
			},

			filterEntradas( ){
				let entradass = this.nominaActual
				if( this.opcionFiltro != 3 ){

					entradass = entradass.filter( el => el.estatus_nomina == this.opcionFiltro )

				} 
				return entradass.filter(el =>  el.puesto !== 'Sin puesto');
			},

			filterEntradasEncargadas( ){
				let entradass = this.nominaActual;

				return entradass.filter(el => el.puesto !== 'Sin puesto' && el.puesto == 'ENCARGADA DE SUCURSAL');
			},

		},

		async created () {
			await this.cargarCiclos()

      // Si es el puesto de asistente de operaciones, y si es el usuario de karen esmeralda, se actualiza el headers
      if( this.getdatosUsuarioERPERP.idpuesto == 88 && [ 2268, 1312 ].includes(this.getdatosUsuarioERPERP.iderp) ){
        this.headers = [
          { text: 'Empleado'              , value: 'nombre_completo'      },
          { text: 'Puesto'                , value: 'puesto'               },
          { text: 'Plantel'               , value: 'plantel'              },
          { text: 'Monto Jornada Laboral' , value: 'monto_laborado'       , align: 'end'},
          { text: 'Monto Horas Extras'    , value: 'monto_horas_extras'   , align: 'end'},
          { text: 'Monto Comisiones'      , value: 'comisiones_semana'    , align: 'end'},
          { text: 'Monto Rebajes'         , value: 'monto_total_rebajes'  , align: 'end'},
          { text: 'Monto Bonos'           , value: 'monto_total_bonos'    , align: 'end'},
          { text: 'Monto Total'           , value: 'monto_total'          , align: 'end'},
        ];
      }else{  
        this.headers = [
          { text: 'Empleado'              , value: 'nombre_completo'      },
          { text: 'Puesto'                , value: 'puesto'               },
          { text: 'Plantel'               , value: 'plantel'              },
        ];
      }
		},

		methods: {

			calcularSemanasCiclo( ciclo ){
				if( !ciclo || !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo ) return []

				const parseDate = ( fecha ) => new Date(fecha.substr(0, 10) + 'T12:00:00')
				const formatDate = ( fecha ) => fecha.toISOString().substr(0, 10)

				const inicio = parseDate(ciclo.fecha_inicio_ciclo)
				const fin = parseDate(ciclo.fecha_fin_ciclo)
				const semanas = []
				let current = new Date(inicio)
				let num = 1

				while( current <= fin ){
					const weekStart = new Date(current)
					const weekEnd = new Date(current)
					weekEnd.setDate(weekEnd.getDate() + 6)
					if( weekEnd > fin ) weekEnd.setTime(fin.getTime())

					semanas.push({
						bloque: `Semana ${ num }`,
						value: num,
						fecha_inicio: formatDate(weekStart),
						fecha_fin: formatDate(weekEnd),
					})

					num++
					current.setDate(current.getDate() + 7)
				}

				this.etiquetarSemanasCiclo( semanas )
				return semanas
			},

			etiquetarSemanasCiclo( semanas ){
				const total = semanas.length
				if( total < 5 ) return

				for( let i = 0; i < total; i++ ){
					const num = i + 1
					if( num === 1 ){
						semanas[i].bloque = 'Semana 1'
					} else if( num === 2 ){
						semanas[i].bloque = 'Semana 2'
					} else if( num === total - 1 ){
						semanas[i].bloque = 'Semana 3'
					} else if( num === total ){
						semanas[i].bloque = 'Semana 4'
					} else {
						semanas[i].bloque = `Semana vacaciones ${ num - 2 }`
					}
				}
			},

			getSemanaSeleccionada(){
				return this.semanasCiclo.find(el => el.value === this.selectedHeaders) || null
			},

			getFechaConsulta(){
				const semana = this.getSemanaSeleccionada()
				if( !semana ) return this.fecha

				if( semana.fecha_fin < this.fecha ) return semana.fecha_fin
				if( this.fecha >= semana.fecha_inicio && this.fecha <= semana.fecha_fin ) return this.fecha
				return semana.fecha_inicio
			},

			actualizarSemanas(){
				this.semanasCiclo = this.calcularSemanasCiclo(this.ciclo)

				if( !this.semanasCiclo.length ){
					this.selectedHeaders = null
					return
				}

				const semanaActual = this.semanasCiclo.find(
					el => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin
				)

				this.selectedHeaders = semanaActual
					? semanaActual.value
					: this.semanasCiclo[this.semanasCiclo.length - 1].value
			},

			async cargarCiclos(){
				this._configurandoFiltros = true
				this.cargar = true
				this.ciclos = []

				try{
					const response = await this.$http.post('roles.get.ciclos.minomina', { fecha: this.fecha })
					this.ciclos = response.data.ciclos || []

					const cicloActual = response.data.ciclo_actual
					if( cicloActual ){
						this.ciclo = this.ciclos.find(el => el.id_ciclo === cicloActual.id_ciclo) || cicloActual
					}else if( this.ciclos.length ){
						this.ciclo = this.ciclos.find(el => {
							const inicio = el.fecha_inicio_ciclo.substr(0, 10)
							const fin = el.fecha_fin_ciclo.substr(0, 10)
							return this.fecha >= inicio && this.fecha <= fin
						}) || this.ciclos[0]
					}

					if( this.ciclo ){
						this.actualizarSemanas()
					}
				}catch( error ){
					let msg = 'Error al cargar ciclos'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this._configurandoFiltros = false
					this.cargar = false
					if( this.ciclo && this.selectedHeaders ){
						this.initialize()
					}
				}
			},

			initialize () {
				if( !this.ciclo || !this.selectedHeaders ) return

				this.cargar = true
				this.nominaActual = []

				const payload = {
					fecha   : this.getFechaConsulta(),
					id_ciclo: this.ciclo.id_ciclo,
					semana  : this.selectedHeaders
				}

				return this.$http.post('usuarios.entradas', payload).then(async response=>{

					let puesto          = this.getdatosUsuarioERPERP.puesto
					let mapIdPlanteles  = this.getdatosUsuarioERPERP.planteles.map((registro) => registro.idplantel);

					// María esther
					if( this.getdatosUsuarioERPERP.iderp == 568 ){ puesto = 'JEFE DE OPERACIONES' }
          
          // Karen Esmeralda
					if( [ 2268, 1312 ].includes(this.getdatosUsuarioERPERP.iderp) ){ puesto = 'JEFE DE OPERACIONES' }

          
					if( this.getdatosUsuarioERPERP.iderp == 2155 ){ puesto = 'JEFE DE OPERACIONES' }
					if( this.getdatosUsuarioERPERP.iderp == 1312 ){ puesto = 'JEFE DE OPERACIONES' }
					if( this.getdatosUsuarioERPERP.iderp == 3015 ){ puesto = 'JEFE DE OPERACIONES' }

					if( this.getdatosUsuarioERPERP.iderp == 626 ){
						puesto         = 'COORDINADOR DE ZONA' 
          	mapIdPlanteles = [29,24,1,23,1,2,3,4,5,6,17,21,22,23,24,32] 
					}

			    // María Isabel Rodríguez Mora
			    if( this.getdatosUsuarioERPERP.iderp == 1196 ){
						puesto         = 'COORDINADOR DE ZONA' 
			    	mapIdPlanteles = [2,3,5,24,1,23,22] 
			    }

			    // Patricia Salazar
			    if( this.getdatosUsuarioERPERP.iderp == 161 ){
						puesto         = 'COORDINADOR DE ZONA' 
			    	mapIdPlanteles = [7,8,9,10,11,12,14,16,20]
			    }

			    // PIEDAD LOPEZ 
			    if( this.getdatosUsuarioERPERP.iderp == 1248 ){
						puesto         = 'COORDINADOR DE ZONA' 
			    	mapIdPlanteles = [11,7,8,10] 
			    }

			    // fernanda oliva espinosa
			    if( this.getdatosUsuarioERPERP.iderp == 1489 ){
						puesto         = 'COORDINADOR DE ZONA' 
			    	mapIdPlanteles = [25,28,27,31,17] 
			    }

			    // Karen Gonzalez
			    if( this.getdatosUsuarioERPERP.iderp == 28 ){
			    	puesto = 'Jefe Finanzas'
			    }

					let puestosDependientes = response.data.organigrama.filter( el => el.puesto_jefe == puesto ).map((registro) => { return registro.puesto_auxiliar })
			    
			    if( this.getdatosUsuarioERPERP.iderp == 954 ){
			    	puestosDependientes = response.data.organigrama.map((registro) => { return registro.puesto_auxiliar })
			    }

					this.nominaActual = response.data.result3.filter( el => puestosDependientes.includes( el.puesto ));
					
					if( this.getdatosUsuarioERPERP.puesto == 'ENCARGADA DE SUCURSAL' && ![568,2268, 1312 ].includes(this.getdatosUsuarioERPERP.iderp) ){
						this.nominaActual = this.nominaActual.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
					}


					if( puesto == 'COORDINADOR DE ZONA' ){
						this.nominaActual = this.nominaActual.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
					}


			    if( this.getdatosUsuarioERPERP.iderp == 7 ){

						this.nominaActual = response.data.result3
			    	
			    }

          if( this.getdatosUsuarioERPERP.iderp == 2844 ){
            this.nominaActual = response.data.result3
          }
          
          if( this.getdatosUsuarioERPERP.iderp == 2120 ){
            this.nominaActual = response.data.result3
          }

				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			verComentarios( value ){

				this.renglonNomina = value

				this.dialogComentarios = true
			},

			responder( ){

				const payload = {
					idnomina_estatus: this.renglonNomina.idnomina_estatus,
					estatus         : 0,
					id_usuario      : this.getdatosUsuarioERPERP.id_trabajador,
					motivo          : this.respuesta,
					idusuarionomina : this.renglonNomina.id_usuario 
				}

				this.$http.post('responder.nomina.jefe', payload ).then(response=>{
          this.validarSuccess( 'Respuesta enviada' )
          this.initialize( )
          this.dialogComentarios = false
          this.respuesta = ''
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
			},

			format( valor ){
			  return valor.toLocaleString('es-MX', {
			    style: 'currency',
			    currency: 'MXN'
			  });
      }
		},
	}
</script>




